import { useState, useEffect } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'
import { useAuthContext } from './context/auth/auth-context'

const REFRESH_EVENT = 'currentUserRefresh'

export const useFeatures = () => {
  const [features, setFeatures] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [refreshCount, setRefreshCount] = useState(0)
  const { user: authUser } = useAuthContext()

  useEffect(() => {
    const handleRefresh = () => setRefreshCount(c => c + 1)
    window.addEventListener(REFRESH_EVENT, handleRefresh)
    return () => window.removeEventListener(REFRESH_EVENT, handleRefresh)
  }, [])

  useEffect(() => {
    async function fetchFeatures() {
      if (!authUser) { setFeatures({}); setLoading(false); setError(null); return }
      setLoading(true)
      setError(null)
      try {
        const { data, error: err } = await supabaseGetter.features.resolveByUser(authUser.id)
        if (err) throw err
        setFeatures(data || {})
      } catch (err) {
        console.error('[useFeatures] Error resolving features:', err)
        setError(err.message)
        setFeatures({})
      } finally {
        setLoading(false)
      }
    }
    fetchFeatures()
  }, [authUser, refreshCount])

  return { features, loading, error, invalidate: supabaseGetter.features.invalidate }
}
